// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cp-b";
export var colorBlue = "_cp-8";
export var colorDot = "_cp-0";
export var colorDotLarge = "_cp-2";
export var colorDotSmall = "_cp-1";
export var colorGreen = "_cp-7";
export var colorGrey = "_cp-3";
export var colorOrange = "_cp-5";
export var colorPink = "_cp-a";
export var colorPurple = "_cp-9";
export var colorRed = "_cp-4";
export var colorYellow = "_cp-6";